export interface ICorporatePartner {
  name: string;
  displayBusinessLogo: boolean;
  updateBgColor: boolean;
  restrictPaxToOne: boolean;
  disableMiles: boolean;
  displayInlineText: string;
  showPopupForEcert: boolean;
  showBusinessText: boolean;
  showBusinessMilesLabel: boolean;
}
